<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "4rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64"><path d="M57 5H20a2 2 0 00-2 2v25H6.5A1.5 1.5 0 005 33.5V51a8 8 0 007.14 8 1.49 1.49 0 00.36 0H51a8 8 0 008-8V7a2 2 0 00-2-2zM8 51V35h10v16a5 5 0 01-10 0zm48 0a5 5 0 01-5 5H19.24A8 8 0 0021 51V8h35z"/><path d="M28 25h22a1 1 0 001-1V14a1 1 0 00-1-1H28a1 1 0 00-1 1v10a1 1 0 001 1zm1-10h20v8H29zM28 34h22a1 1 0 000-2H28a1 1 0 000 2zM28 41h22a1 1 0 000-2H28a1 1 0 000 2zM28 48h12a1 1 0 000-2H28a1 1 0 000 2z"/></svg>